"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationView = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const ConversationController_1 = require("@opsbase/react-ctrl-conversation/ConversationController");
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const MessageAndHistoryIcon_1 = __importDefault(require("@opsbase/web-icons/icons/MessageAndHistoryIcon"));
const MessageIcon_1 = __importDefault(require("@opsbase/web-icons/icons/MessageIcon"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Button_1 = require("@opsbase/web-ui/Button");
const react_1 = __importStar(require("react"));
const ConversationStaffPicker_1 = __importDefault(require("../ConversationStaffPicker"));
const IssueActivity_1 = __importDefault(require("./IssueActivity"));
const MessageView_1 = __importDefault(require("./MessageView"));
const PhotoTextInput_1 = __importDefault(require("./PhotoTextInput"));
const makeMyClasses = invertLayout => ({
    root: {
        maxHeight: '100%',
        flexWrap: 'nowrap',
        border: `1px solid ${lib_palette_1.default.InputBorderGrey.main}`,
        backgroundColor: 'white',
        borderRadius: 8,
        overflow: 'hidden',
    },
    comments: {
        flex: 1,
        width: '100%',
        overflow: 'auto',
    },
    commentPane: {
        borderTop: invertLayout ? undefined : `1px solid ${lib_palette_1.default.InputBorderGrey.main}`,
        borderBottom: !invertLayout ? undefined : `1px solid ${lib_palette_1.default.InputBorderGrey.main}`,
        boxShadow: invertLayout
            ? `4px 0 12px -4px ${lib_palette_1.default.LavendarGrey.main}`
            : `-4px 0 12px -4px ${lib_palette_1.default.LavendarGrey.main}`,
    },
});
function ConversationView() {
    const { initiateEditMessage, cancelEditMessage, saveMessage, deleteMessage, setText, setShadowStaffId, setImages, cycleTimelineViewState, } = (0, ConversationController_1.useConversationActions)();
    const { text, editable, timezone, placeholderText, timelineData, shadowStaffId, images, hasActivity, timelineViewState, simpleCallouts, invertLayout, isSavingMessage, editingMessageIndex, } = (0, ConversationController_1.useConversations)();
    const self = (0, useSelf_1.default)();
    const textFieldRef = (0, react_1.useRef)();
    const currentCommentRef = (0, react_1.useRef)();
    const updateTextFieldRef = (0, react_1.useCallback)(r => (textFieldRef.current = r), []);
    const myCss = (0, web_css_1.default)(makeMyClasses, [invertLayout]);
    const handleInitiateEditComment = (0, react_1.useCallback)((comment, index) => {
        initiateEditMessage(comment, index);
        textFieldRef.current.focus();
    }, [initiateEditMessage]);
    const addNewPlaceholder = placeholderText !== null && placeholderText !== void 0 ? placeholderText : lib_i18n_1.default.t('add-comment-placeholder');
    (0, react_1.useEffect)(() => {
        if (!invertLayout)
            setTimeout(() => { var _a; return (_a = currentCommentRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', block: 'end' }); }, 500);
    }, [invertLayout]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (!isSavingMessage || editingMessageIndex > 0)
            (_a = currentCommentRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }, [editingMessageIndex, isSavingMessage]);
    const timelineViews = (0, react_1.useMemo)(() => timelineData === null || timelineData === void 0 ? void 0 : timelineData.map((timelineItem, idx) => {
        var _a;
        if (timelineItem.comment) {
            const { comment, staff, commentIndex, editing, isSelf, firstItem, lastItem } = timelineItem;
            return (react_1.default.createElement(MessageView_1.default, { key: (_a = comment.id) !== null && _a !== void 0 ? _a : `comment_${idx}`, refProp: idx === timelineData.length - 1 ||
                    editingMessageIndex === commentIndex
                    ? currentCommentRef
                    : null, comment: comment, commentor: staff, editable: editable, commentIndex: commentIndex, editing: editing, timezone: timezone, isSelf: isSelf, onDeleteComment: deleteMessage, onEditComment: handleInitiateEditComment, onCancelEditComment: cancelEditMessage, firstItem: firstItem, lastItem: lastItem, simpleCallouts: simpleCallouts }));
        }
        else {
            const { activity, staff, isSelf, firstItem, lastItem } = timelineItem;
            return (react_1.default.createElement(IssueActivity_1.default, { key: `activity_${idx}`, refProp: idx === timelineData.length - 1 ? currentCommentRef : null, activity: activity, commentor: staff, timezone: timezone, isSelf: isSelf, firstItem: firstItem, lastItem: lastItem }));
        }
    }), [
        cancelEditMessage,
        deleteMessage,
        editable,
        editingMessageIndex,
        handleInitiateEditComment,
        simpleCallouts,
        timelineData,
        timezone,
    ]);
    const commentTextField = (0, react_1.useMemo)(() => {
        if (!editable)
            return null;
        return (react_1.default.createElement(PhotoTextInput_1.default, { updateTextFieldRef: updateTextFieldRef, editable: true, placeholderText: addNewPlaceholder, text: text, onTextChange: setText, onSave: saveMessage, images: images, onImagesChange: setImages, isSaving: isSavingMessage }));
    }, [
        addNewPlaceholder,
        editable,
        images,
        saveMessage,
        setImages,
        setText,
        text,
        updateTextFieldRef,
        isSavingMessage,
    ]);
    const commentPane = (0, react_1.useMemo)(() => {
        if (self.isStaff)
            return commentTextField;
        return (react_1.default.createElement(Vertical_1.default, { shrink: true, classes: { root: myCss.commentPane } },
            !!shadowStaffId && commentTextField,
            react_1.default.createElement(ConversationStaffPicker_1.default, { onChange: setShadowStaffId })));
    }, [commentTextField, myCss, self, setShadowStaffId, shadowStaffId]);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(Vertical_1.default, { classes: { root: myCss.root + ' ConversationView' } },
        invertLayout ? commentPane : null,
        hasActivity ? (react_1.default.createElement(Button_1.Button, { small: true, round: true, style: {
                position: 'absolute',
                right: 16,
                top: 16,
                zIndex: 9999,
            }, color: lib_palette_1.default.HelixNotificationBold, disabled: false, onClick: cycleTimelineViewState }, timelineViewState === ConversationController_1.TimelineViewState.MessagesOnly ? (react_1.default.createElement(MessageIcon_1.default, { size: 16 })) : (react_1.default.createElement(MessageAndHistoryIcon_1.default, { size: 16 })))) : null,
        react_1.default.createElement(Pane_1.default, { classes: { root: myCss.comments } }, timelineViews),
        invertLayout ? null : commentPane)), [
        commentPane,
        cycleTimelineViewState,
        hasActivity,
        invertLayout,
        myCss,
        timelineViewState,
        timelineViews,
    ]);
}
exports.ConversationView = ConversationView;
exports.default = ConversationView;
